import { put, call, takeLatest } from "redux-saga/effects";
import * as Actions from "us.collection.admin/actions";
import * as API from "us.collection.admin/services";
import { StandardRates } from "us.collection.admin/constants";
import {
  formatStandardRates,
  sortStandardRatesHistory,
} from "us.collection.admin/functions";
import Common from "us.common";
import { i18n } from "us.helper";

const { $MessageBox, $Message } = Common.Components;

const { standardRates } = Actions;
const { search, detail } = API.standardRates;
const { init, addStandardRate, editStandardRate } = standardRates;
const {
  INIT_GET_STANDARD_RATES,
  ADD_STANDARD_RATE,
  EDIT_STANDARD_RATE,
  DELETE_STANDARD_RATE,
} = StandardRates;

export const StandardRatesSagas = {
  standardRatesSearch: {
    init: function* (): any {
      try {
        const { standardRatesList, standardRatesHistory } = yield call(
          search.init
        );

        yield put(
          init.success({
            standardRates: formatStandardRates(standardRatesList),
            standardRatesHistory:
              sortStandardRatesHistory(standardRatesHistory),
          })
        );
      } catch (error) {
        yield put(init.fail(new Error()));
      }
    },
    delete: function* (action: any) {
      const params = action?.payload?.data ?? {};
      $Message.loading(i18n.t("COMMON.DELETING") as string, 0);
      try {
        const { deleteData, status } = yield call(search.delete, params);
        $Message.destroy();

        if (!deleteData?.isError && status === 200) {
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_DELETED_SUCCESSFULLY",
            "",
            ""
          );

          if (init.get) yield put(init.get({}));
          if (init.manageDrawer) yield put(init.manageDrawer({}));
        } else {
          if (deleteData?.errorCode == 2) {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.SORRY_UNABLE_TO_DELETE_A_PAST_RATE",
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_DELETE_FAILED",
              "",
              ""
            );
          }
          yield put(init.fail(new Error()));
        }
      } catch (error) {
        $Message.destroy();
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_DELETE_FAILED",
          "",
          ""
        );
        yield put(init.fail(new Error()));
      }
    },
  },
  standardRateDetail: {
    add: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { saveData, saveStatus } = yield call(detail.add, params);
        if (!saveData?.isError && saveStatus === 201) {
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_ADDED_SUCCESSFULLY",
            "",
            ""
          );
          yield put(addStandardRate.success(saveData));

          if (init.get) yield put(init.get({}));
          if (init.manageDrawer) yield put(init.manageDrawer({}));
        } else {
          if (saveData?.errorCode == 1) {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.SORRY_THERE_IS_A_RATE_ALREADY_FOR_THE_SELECTED_EFFECTIVE_DATE",
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.SAVE_RATE_FAILED",
              "",
              ""
            );
          }
          yield put(addStandardRate.fail(new Error()));
        }
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:STANDARD_RATE.SAVE_RATE_FAILED",
          "",
          ""
        );
        yield put(addStandardRate.fail(new Error()));
      }
    },
    edit: function* (action: any) {
      const params = action?.payload?.data ?? {};
      try {
        const { saveData, saveStatus } = yield call(detail.edit, params);
        if (!saveData?.isError && saveStatus === 201) {
          $MessageBox(
            "success",
            "US.COLLECTION.ADMIN:STANDARD_RATE.RATE_UPDATED_SUCCESSFULLY",
            "",
            ""
          );
          yield put(editStandardRate.success(saveData));

          if (init.get) yield put(init.get({}));
          if (init.manageDrawer) yield put(init.manageDrawer({}));
        } else {
          if (saveData?.errorCode == 1) {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.SORRY_THERE_IS_A_RATE_ALREADY_FOR_THE_SELECTED_EFFECTIVE_DATE",
              "",
              ""
            );
          } else {
            $MessageBox(
              "error",
              "US.COLLECTION.ADMIN:STANDARD_RATE.SAVE_RATE_FAILED",
              "",
              ""
            );
          }
          yield put(editStandardRate.fail(new Error()));
        }
      } catch (error) {
        $MessageBox(
          "error",
          "US.COLLECTION.ADMIN:STANDARD_RATE.SAVE_RATE_FAILED",
          "",
          ""
        );
        yield put(editStandardRate.fail(new Error()));
      }
    },
  },
};

export default [
  takeLatest(
    INIT_GET_STANDARD_RATES,
    StandardRatesSagas.standardRatesSearch.init
  ),
  takeLatest(ADD_STANDARD_RATE, StandardRatesSagas.standardRateDetail.add),
  takeLatest(EDIT_STANDARD_RATE, StandardRatesSagas.standardRateDetail.edit),
  takeLatest(
    DELETE_STANDARD_RATE,
    StandardRatesSagas.standardRatesSearch.delete
  ),
];
